import React from 'react';
import { map } from 'lodash';
import classnames from 'classnames';
import render_raw_html from '../../../common/render_raw_html';
import remoteFiles from '../../../common/remote_files';
import FooterSocialMenu from './components/footerSocialMenu';

// V4_Fios TV Dual Lockup_wdis
const VerizonTv1 = ({ emailData }) => {
  const { telNumber, name, receiver } = emailData;
  const {
    nSwitch,
    phone,
    dollarIcon: dollar,
    displayIcon: display,
    careIcon: care
  } = remoteFiles.verizon.emailApp.concept2;

  const plans = [
    {
      header: "For multiple devices in every room",
      title: "1 Gig",
      oldPrice: "$100/mo",
      newPrice: "$75/mo",
      note: "With Auto Pay and any Verizon mobile phone plan.*",
      lockTitle: "5-year price lock guarantee",
      device: {
        title: "Plus, get the Nintendo Switch<sup>TM</sup> system, on us**",
        imageSrc: nSwitch,
        imageAlt: "Nintendo Switch",
        note: "(Retail value: $339.99)"
      },
      selectTitle: "Get Fios 1 Gig"
    },
    {
      header: "For your everyday internet needs",
      title: "300 Mbps",
      oldPrice: "$60/mo",
      newPrice: "$35/mo",
      note: "With Auto Pay and any Verizon mobile phone plan.*",
      lockTitle: "3-year price lock guarantee",
      selectTitle: "Make the switch"
    }
  ];

  const extras = [
    {
      iconSrc: dollar,
      iconKlass: "-dollar",
      title: "Save by bundling mobile and home",
      description: "Our Mobile + Home Discount gets you savings on your home internet bill when you bundle both services.^"
    },
    {
      iconSrc: display,
      iconKlass: "-display",
      title: "Your choice of perk, on us",
      description: "Pick a subscription for entertainment, music, streaming and more, with Fios 1 Gig. Up to $10/mo in value.^^"
    },
    {
      iconSrc: care,
      iconKlass: "-care",
      title: "Priority Care",
      description: "With benefits like faster access to our most experienced reps."
    }
  ];

  return (
    <div className="email with-little-padding">
      <div className="email_header">
        <div className="email_header-logo">
          <svg className="email_header-logo-img">
            <use xlinkHref={ `#svg_verizon-long-branded` } />
          </svg>
        </div>
        <ul className="email_header-menu">
          <li>Shop</li>
          <li>Support</li>
          <li>My Verizon</li>
        </ul>
      </div>

      <div className="verizon-tv-page">
        <section className="hero">
          <div className="hero-content -with-max-restriction">
            <p className="subtitle">What if you could</p>
            <h1>Unlock all this <br /> and more for less</h1>
            <p className="description">
              Verizon mobile customers like you can save when you bundle your mobile phone plan with Fios 1 Gig for $75/mo.
            </p>
            <p className="fine-print">With Auto Pay and any Verizon mobile phone plan.*</p>
            <button>Show me how</button>
          </div>
        </section>

        <section className="main-padding">
          <section className="intro">
            <h2>Ultrafast? Reliable?<br /><span>That&rsquo;s just the start</span></h2>
            <p>{ name },</p>
            <p>
              Fios Home Internet helps you jump into whatever you want, like the next episode,
              { ' ' }
              game level or playlist addition—as often as you want.
            </p>
            <p>
              Plus, just for being a Verizon mobile customer, you get a $15/mo discount
              { ' ' }
              on your home internet bill.^
            </p>
          </section>

          <section className="plan-selector">
            <h3>Choose your plan</h3>
            <div className="plans">
              {
                map(plans, (plan, index) => (
                  <article className="plan-card" key={ `plan${index}` }>
                    <div className="plan-header">
                      <span className="plan-type" { ...render_raw_html(plan.header) } />
                    </div>
                    <div className="plan-card-content">
                      <h4 { ...render_raw_html(plan.title) } />
                      <div className="plan-price">
                        <span className="old-price" { ...render_raw_html(plan.oldPrice) } />
                        <span className="price" { ...render_raw_html(plan.newPrice) } />
                        <p className="note" { ...render_raw_html(plan.note) } />
                        <div className="guarantee -with-margin-top">
                          <svg className="email-lock"><use xlinkHref="#svg_lock" /></svg>
                          <p { ...render_raw_html(plan.lockTitle) } />
                        </div>
                      </div>
                      {
                        !!plan.device &&
                        <div className="device-offer">
                          <p { ...render_raw_html(plan.device.title) } />
                          <div className="image-wrapper">
                            <img src={ plan.device.imageSrc } alt={ plan.device.imageAlt } />
                          </div>
                          <small { ...render_raw_html(plan.device.note) } />
                        </div>
                      }
                    </div>
                    <span className="primary-link">
                      { plan.selectTitle }
                      { ' ' }
                      <span className="email_icon-more" />
                    </span>
                  </article>
                ))
              }
            </div>
          </section>
        </section>

        <section className="hero extras">
          <div className="hero-content">
            <h3><span className="yellow">Love extras?</span> <span className="white">We&rsquo;ve got plenty</span></h3>
            <div className="extras-grid">
              {
                map(extras, (extra, index) => (
                  <article key={ `extra${index}` }>
                    <div className={ classnames("icon", extra.iconKlass) }>
                      <img src={ extra.iconSrc } alt="Icon" />
                    </div>
                    <h4 { ...render_raw_html(extra.title) } />
                    <p { ...render_raw_html(extra.description) } />
                  </article>
                ))
              }
            </div>
            <span className="primary-link white">
              Let&rsquo;s do this
              { ' ' }
              <span className="email_icon-more" />
            </span>
          </div>
        </section>

        <section className="fios-tv">
          <div className="tv-image" aria-hidden="true">
            <img src={ phone } alt="Phone" />
          </div>
          <div className="tv-copy">
            <h4>Meet a million possibilities <span className="red">with&nbsp;Fios&nbsp;TV+</span></h4>
            <p>
              Fios TV delivers entertainment you’ll love. The channels you want.
              { ' ' }
              TV that’s stunning with 4K clarity. TV you can talk to — and so much more.
              Plus, get a $200 Verizon Gift Card<sup>‡</sup> when you add The Most Fios TV.<sup>†</sup>
            </p>
            <span className="link">
              Check it out
              { ' ' }
              <span className="email_icon-more" />
            </span>
          </div>
        </section>

        <section className="email_content-section">
          <div className="email_banner -grid">
            <div className="email_banner-image -in-grid">
              <svg className="email_banner-image-img">
                <use xlinkHref={ `#svg_verizon-short-branded` } />
              </svg>
            </div>
            <div className="email_banner-content -in-grid">
              Powering how you live, work and play
            </div>
          </div>
        </section>

        <div className="email_content-section footer-buttons">
          <div className="email_content-cols">
            <div className="email_content-col">
              <div className="email_content-plate -black -text-white">
                <div className="email_content-plate-grid">
                  <div className="email_content-plate-p -bold -md">
                    Find a store
                  </div>
                  <div className="email_icon-arrow-out" />
                </div>
              </div>
            </div>
            <div className="email_content-col">
              <div className="email_content-plate -black -text-white">
                <div className="email_content-plate-grid">
                  <div className="email_content-plate-p -bold -md">Call { telNumber }</div>
                  <div className="email_icon-arrow-out" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="email_footer tv-email-footer">
        <ul className="email_footer-menu -main">
          <li>Phones</li>
          <li>Accessories</li>
          <li>Plans</li>
          <li>Verizon Access</li>
          <li>My Verizon app</li>
          <li>Contact us</li>
        </ul>
        <FooterSocialMenu />
        <div className="email_footer-texts">
          <p>
            <b>*Fios: General:</b>
            { ' ' }
            Fios 300 Mbps plan at $35/mo. or Fios 1 Gig plan at $75/mo. when combined with
            { ' ' }
            postpaid Verizon mobile phone plan (excludes business and data-only plans).
            { ' ' }
            Auto Pay & paper-free billing req’d. Mobile + Home Discount enrollment req’d.
            { ' ' }
            $99 setup and other terms may apply. Availability varies. Subject to credit approval.
            { ' ' }
            Wired and wireless speeds may vary due to device limits, multiple users, network & other factors.
            { ' ' }
            See <span className="pseudo-link">verizon.com/yourspeed</span> for more info.
            { ' ' }
            <b>Fios 1 Gig:</b> Gigabit network connection to your home.
            { ' ' }
            Wired speeds up to 940/880 Mbps with avg. speeds between 750–940 Mbps download / 750–880 Mbps upload.
            { ' ' }
            <b>3- or 5-Year Price Guarantee:</b> For Verizon Home Internet customers on a new or current internet plan.
            { ' ' }
            Applies only to the then-current base monthly rate exclusive of any other setup and
            { ' ' }
            additional equipment charges, discounts or promotions, plan perk and any other
            { ' ' }
            third-party services.
          </p>
          <p>
            <b>^Mobile + Home Discount:</b> $15/mo. savings on Verizon Home Internet plans
            { ' ' }
            when combined with postpaid Verizon mobile phone plan
            { ' ' }
            (excludes business and data-only plans). Enrollment req’d.
          </p>
          <p>
            <b>**The Nintendo Switch System:</b> Offer valid thru 12/15/25 for the
            { ' ' }
            Nintendo Switch system – Neon Blue and Neon Red Joy-Con. For new home internet
            { ' ' }
            customers who install and maintain eligible Fios 1 Gig services in good standing for 65 days.
            { ' ' }
            Redemption terms apply. Verizon reserves the right to charge back the value of the
            { ' ' }
            Nintendo promotional device if eligible service is canceled w/in 180 days.
            { ' ' }
            One offer per eligible Verizon account, while supplies last.
          </p>
          <p>
            <b>^^Perk On Us Credit:</b> Availability of each perk is subject to specific terms
            { ' ' }
            and age requirements. Requires one paid perk on eligible Verizon mobile phone line
            { ' ' }
            or eligible home internet plan. Up to $10/month credit will be applied to your
            { ' ' }
            Fios Internet bill as long as one paid perk remains active on either account.
            { ' ' }
            Perk credit canceled if paid perk removed, mobile line or home internet plan canceled,
            { ' ' }
            or home internet moved to ineligible plan. Perk promotional offers are not eligible
            { ' ' }
            for the perk discount. Credit applied in 1–2 billing cycles.
          </p>
          <p>
            <b><sup>†</sup>Fios TV:</b> For eligible new res. custs. Availability varies.
            { ' ' }
            $99 setup & taxes & terms may apply. Auto Pay & paper-free billing required.
            { ' ' }
            Subject to credit approval. Full Fios TV functionality requires a Verizon router and
            { ' ' }
            non-Fios internet customers using a Verizon router may be subject to a $18/mo.
            { ' ' }
            Verizon router rental fee.
          </p>
          <p>
            <b><sup>‡</sup>Verizon Gift Card:</b> Must install and maintain eligible Fios services in good
            { ' ' }
            standing for 65 days and register for the Gift Card w/in 60 days thereafter.
            { ' ' }
            Gift Card emailed within 48 hours of registration. We reserve the right to charge
            { ' ' }
            back the amount of the Gift Card if eligible service is canceled w/in 180 days.
            { ' ' }
            Other Gift Card terms and conditions apply. One offer per eligible Verizon account.
          </p>
          <p>© 2025 Verizon</p>
          <p>
            This email was sent to { receiver }. We respect your privacy.
            { ' ' }
            Please review our <span className="pseudo-link">Privacy Policy</span>.
            { ' ' }
            California customers can view our <span className="pseudo-link">California Privacy Notice</span>.
            { ' ' }
            You may <span className="pseudo-link">unsubscribe</span> or update your subscription preferences for your
            { ' ' }
            Verizon promotional emails at any time.
          </p>
          <p>Verizon, One Verizon Way, Mail Code: 180WVB, Basking Ridge, NJ 07920</p>
        </div>
      </div>
    </div>
  );
};

export default VerizonTv1;
